import React from "react";
import "./index.scss";
import noItemFoundImg from "../../assets/images/no-result-icon.png";

const NoDataFound = ({ text }) => {
  return (
    <div className="no-data-found-container">
      <img className="no-data-icon" src={noItemFoundImg} alt="" />
      <h5>{text ? text : "Results not found"}</h5>
      <p>There is no data to show you right now.</p>
    </div>
  );
};

const NoItemFound = () => {
  return (
    <div className="no-data-found-container mt-0 mb-0 no-item-found">
      <img className="no-data-icon" src={noItemFoundImg} alt="" />
      <p className="mt-0">Results not found.</p>
    </div>
  );
};

export {
  NoDataFound,
  NoItemFound
};

